export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_14.4edc9c18.jpg";